export default __webpack_public_path__ + "static/logo-844b3f69f53ac99752db18fcf5bd7acc.svg";